import { AppState } from '../../store/models/app-state';

export const selectedLanguageSelector = (state: AppState) => state.selectedLanguage.selectedLanguage;
